import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { StatusLogDataType } from './type'
import type { FilterStatusValues, MutationStatusValues } from './validation'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['global', key] as const

const getAllStatus = (
  params?: FilterStatusValues
): ServiceQueryOptionType<ServiceGetAllResponse<Array<StatusLogDataType>>> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<StatusLogDataType>>
      >(params?.url ?? '', {
        params
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const createStatus = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<StatusLogDataType>,
  MutationStatusValues
> => ({
  mutationFn: async (data: MutationStatusValues) => {
    try {
      const formData = new FormData()

      // Add all fields to FormData
      formData.append('status_baru', data.status_baru === 'AKTIF' ? '1' : '0')
      formData.append('tanggal', data.tanggal)
      formData.append('alasan', data.alasan || '')
      // Add file if exists
      if (data.lampiran) {
        formData.append('lampiran', data.lampiran)
      }

      const response = await api.post<
        ServiceGetByIdResponse<StatusLogDataType>
      >(data.url ?? '', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const global = {
  getAllStatus,
  createStatus
}
